export default {
    GET_CALCULATIONS_REQUEST: state => {
        state.calculationsLoading = true
    },
    GET_CALCULATIONS_SUCCESS: (state, data) => {
        state.calculations = data.results
        state.calculationsLoading = false
    },
    GET_CALCULATIONS_FAILURE: state => {
        state.calculationsLoading = false
    },

    GET_CALCULATION: (state, calculation) => {
        state.calculation = calculation
    },

    GET_CALCULATIONS_STATUS_LIST: (state, data) => {
        state.calculationStatusList = data.results
    },

    TEMPORARY_SAVE_CALCULATION_DATA: (state, { name, customer, customerId }) => {
        state.calculation.name = name
        state.calculation.customer = customer
        state.calculation.customerId = customerId
    },

    GET_CALCULATION_PRINT_COLORS: (state, data) => {
        state.calculationPrintColors = data.results
    },

    ADD_CALCULATION_PRODUCT: (state, product) => {
        state.calculation.calculationProducts.push(product)
    },
    COPY_CALCULATION_PRODUCT: (state, product) => {
        state.calculation.calculationProducts.push({
            amount: product.amount,
            calculationProductComponents: product.calculationProductComponents.map(component => ({
                calculationComponentProcesses: component.calculationComponentProcesses.map(process => ({
                    productionProcessId: process.productionProcessId
                })),
                calculationImpositionId: null,
                calculationProductComponentProperties: component.calculationProductComponentProperties.map(property => ({
                    productProductionPropertyId: property.productProductionPropertyId,
                    value: property.value
                })),
                component: component.component,
                componentId: component.componentId,
                parts: component.parts,
            })),
            formatA: product.formatA,
            formatB: product.formatB,
            name: productNameHandler(product.name),
            numberOfVersions: product.numberOfVersions,
            productType: {
                name: product.productType.name,
            },
            productTypeId: product.productTypeId,
            signalAmount: product.signalAmount,
        })

        function productNameHandler(value) {
            const calculationProductsNames = state.calculation.calculationProducts.map(item => item.name),
                regex = RegExp('\\(([\\d]+)\\)'), // (x)
                copiedProductName = value.match(regex),
                originalProductName = copiedProductName ? copiedProductName.input.slice(0, copiedProductName.index - 1) : value

            let ordinalNumbers = []

            calculationProductsNames.forEach(name => {
                const matched = name.match(regex),
                    productName = matched ? matched.input.slice(0, matched.index - 1) : name

                if (productName === originalProductName) {
                    matched ? ordinalNumbers.push(parseInt(matched[1])) : ordinalNumbers.push(0)
                }
            })

            return ordinalNumbers.length > 0 ? `${originalProductName} (${Math.max(...ordinalNumbers) + 1})` : value
        }
    },
    UPDATE_CALCULATION_PRODUCT: (state, product) => {
        const index = state.calculation.calculationProducts.findIndex(item => item.id === product.id)

        state.calculation.calculationProducts[index] = product
    },
    REMOVE_CALCULATION_PRODUCT: (state, id) => {
        const index = state.calculation.calculationProducts.findIndex(item => item.id === id)

        state.calculation.calculationProducts.splice(index, 1)
    },

    CREATE_NEW_IMPOSITIONS: (state) => {
        if (state.calculation.calculationImpositions.length === 0) {
            state.calculation.calculationProducts.forEach(product => {
                const calculationProductComponentIds = product.calculationProductComponents.map(component => (
                    component.id
                ))

                state.calculation.calculationImpositions.push({
                    calculationImpositionTasks: [],
                    calculationProductComponentIds: calculationProductComponentIds
                })
            })
        }
    },

    ADD_IMPOSITION: (state, imposition) => {
        state.calculation.calculationImpositions.push({
            calculationImpositionTasks: [],
            calculationProductComponentIds: imposition.calculationProductComponentIds,
            index: imposition.index || null,
            componentsChanged: true
        })
    },
    REMOVE_IMPOSITION: (state, impositionId) => {
        const impositionIndex = state.calculation.calculationImpositions.findIndex(item => item.id === impositionId)

        state.calculation.calculationImpositions.splice(impositionIndex, 1)
    },
    UPDATE_IMPOSITION: (state, imposition) => {
        const impositionIndex = state.calculation.calculationImpositions.findIndex(item => {
            if (typeof item.index !== 'undefined') {
                return item.index === imposition.index
            } else {
                return item.id === imposition.id
            }
        })

        if (impositionIndex >= 0) {
            state.calculation.calculationImpositions[impositionIndex] = imposition
        }
    },

    SET_PRODUCT_COMPONENT: (state, component) => {
        const calculationProductsIndex = state.calculation.calculationProducts.findIndex(item => item.id === component.calculationProductId),
            calculationProductsComponentIndex = state.calculation.calculationProducts[calculationProductsIndex].calculationProductComponents.findIndex(item => item.id === component.id)

        state.calculation.calculationProducts[calculationProductsIndex].calculationProductComponents[calculationProductsComponentIndex] = component
    },
    SET_CALCULATIONS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_CALCULATIONS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}